import { useState } from "react";
import { Box, Typography, CircularProgress, IconButton } from "@mui/material";
import {
  VideoFile as VideoIcon,
  Download as DownloadIcon,
} from "@mui/icons-material";

export const VideoViewer = ({ url, selectedFile }: any) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<any>(null);

  const handleVideoLoad = () => {
    setLoading(false);
    setError(null);
  };

  const handleVideoError = () => {
    setLoading(false);
    setError("Failed to load video");
  };

  const handleDownload = () => {
    if (url && selectedFile) {
      const link = document.createElement("a");
      link.href = url;
      link.download = selectedFile.name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      {/* Video Controls */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          p: 1,
          borderBottom: 1,
          borderColor: "divider",
        }}
      >
        <Typography variant="body2">Video Preview</Typography>
        <Box sx={{ flexGrow: 1 }} />
        <IconButton
          onClick={handleDownload}
          size="small"
          title="Download Video"
        >
          <DownloadIcon />
        </IconButton>
      </Box>

      {/* Video Content */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          p: 2,
          position: "relative",
          overflow: "auto",
        }}
      >
        {loading && (
          <Box
            sx={{
              position: "absolute",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress size={24} />
            <Typography variant="body2" sx={{ mt: 2 }}>
              Loading video...
            </Typography>
          </Box>
        )}

        {error ? (
          <Box sx={{ textAlign: "center", color: "text.secondary" }}>
            <VideoIcon sx={{ fontSize: 48, mb: 1 }} />
            <Typography variant="body2" color="error">
              {error}
            </Typography>
          </Box>
        ) : (
          <video
            src={url}
            controls
            onLoadedData={handleVideoLoad}
            onError={handleVideoError}
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              borderRadius: 0,
              display: loading ? "none" : "block",
            }}
          />
        )}
      </Box>
    </Box>
  );
};

export default VideoViewer;
